import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom"; 
import "./App.css";

// Layout Components
import Head from "./components/Header/Header";
import Foter from "./components/Footer/Footer";
import Sidebar from "./components/Header/sidebar";

// Public Pages
import Homepage from "./components/Homepage";
import GLOCYBSLearning from "./components/Learning/learning";
import Homepage1 from "./components/Learning/home";
import FeedbackForm from "./components/FeedbackForm/FeedbackForm";

// Authentication
import AdminAuth from "./components/SignupLogin/SignupLogin";

// Admin Dashboard
import AdminDashboard from "./components/FeedbackForm/AdminDashboard";

// Super Admin
import SuperAdminLogin from "./components/SuperAdmin/SuperAdminLogin";
import SuperAdminApproval from "./components/SuperAdmin/SuperAdminApproval";

//pdfsearch
import GlocybsPDFSearch from "./components/GLOCYBSPDF/GlocybsPDFSearch";


// ============================================================
// 🔐 ADMIN PROTECTED ROUTE
// ============================================================
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAdminLoggedIn") === "true";

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return children;
};

// ============================================================
// 🔐 SUPER ADMIN PROTECTED ROUTE
// ============================================================
const SuperAdminRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("isAdminLoggedIn") === "true";
  const user = JSON.parse(localStorage.getItem("user_data") || "{}");

  if (!isAuthenticated) return <Navigate to="/super-admin/login" replace />;

  if (user.role !== "super_admin") {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
};


function App() {
  const location = useLocation();

  // ❌ Remove /form so header+sidebar appear on form page
  const noLayoutRoutes = [
    // "/form",  // REMOVE THIS LINE TO SHOW HEADER + SIDEBAR
    "/login",
    "/super-admin/login"
  ];

  const showLayout = !noLayoutRoutes.includes(location.pathname);

  return (
    <div className="App">
      
      {/* Header + Sidebar visible on all pages except login pages */}
      {showLayout && <Head />}
      {showLayout && <Sidebar />}

      <main className="App-main">
        <Routes>

          {/* ======================= PUBLIC ROUTES ======================= */}
          <Route path="/" element={<Homepage />} />
          <Route path="/learning" element={<GLOCYBSLearning />} />
          <Route path="/vidya" element={<Homepage1 />} />

          {/* ⭐ Feedback form is PUBLIC + shows header/sidebar */}
          <Route path="/form" element={<FeedbackForm />} />
          <Route path="/pdfsearch" element={<GlocybsPDFSearch />} />

          {/* ======================= AUTH ROUTES ======================= */}
          <Route path="/login" element={<AdminAuth />} />

          {/* ======================= ADMIN PROTECTED ROUTES ======================= */}
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            } 
          />

          {/* ======================= SUPER ADMIN ROUTES ======================= */}
          <Route path="/super-admin/login" element={<SuperAdminLogin />} />

          <Route
            path="/super-admin/approvals"
            element={
              <SuperAdminRoute>
                <SuperAdminApproval />
              </SuperAdminRoute>
            }
          />

        </Routes>
      </main>

      {/* Footer visible only on layout pages */}
      {showLayout && <Foter />}

    </div>
  );
}

export default App;
